export default __webpack_public_path__ + "static/media/fn-basics.ba2828e9.png";